<template>
  <div v-if="billingSettings" class="custom-switch-billing">
    <b-form-checkbox v-model="billingSettings.add_transactions_as_costs" @change="addPremiumReceiptAsCost()" switch size="lg">
      <translate>Add subscription invoices automatically as costs</translate>
      <font-awesome-icon id="tt_receipts_as_cost" icon="fa-solid fa-circle-info" class="text-info ml-1" />
      <b-tooltip target="tt_receipts_as_cost" triggers="hover">
          {{ $gettext('If you select this option, the invoices that Gekko sends you, will be automatically added to your expenses. Please be aware that you do not duplicate your costs by uploading the copy you receive via email.') }}
      </b-tooltip>
    </b-form-checkbox>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BillingSettingService from "@/store/services/billingsetting.service";

export default {
  name: "AddPremiumReceiptAsCost",
  created() {
  },
  computed: {
    ...mapGetters({ 
      billingSettings: 'subscriptionStore/getBillingSettings'
    })
  },
  methods: {
    addPremiumReceiptAsCost(){
      BillingSettingService.toggleAddTransactionAsCost();
    }
  }
}
</script>

<style lang="scss">
.custom-switch-billing {
  padding: 1rem;
  border-radius: $radiusLg;
  background: white;
  box-shadow: $settingShadow;
  .custom-switch.b-custom-control-lg {
    .custom-control-label {
      font-size: 16px !important;
      &:before, &:after {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .custom-control-input:checked ~ .custom-control-label::after {
      transform: translate(0.9375rem, -50%);
    }
  }
}

</style>
